import { uniqueByKey } from "kinnect-helpers";
import {
	Model,
	YardDriver,
	YardSchedule,
	YardTripDeliveryNote,
	YardTripError,
	YardTruck
} from ".";

export default class Trip extends Model {
	get singularNoun() {
		return "trip";
	}

	get mutations() {
		return {
			deliveryNote: YardTripDeliveryNote,
			drivers: YardDriver,
			errors: YardTripError,
			schedules: YardSchedule,
			truck: YardTruck
		};
	}

	get completed() {
		return this.status === "Completed";
	}

	get driverNames() {
		if ( this.drivers ) {
			return this.drivers.map( driver => driver.user.shortName ).join( ", " );
		}
	}

	get errorTypeNames() {
		if ( this.error ) {
			return this.errorTypes.map( type => type.name ).join( ", " );
		}
	}

	get purchaseOrders() {
		if ( this.schedules ) {
			const purchaseOrders = this.schedules.reduce(
				( total, current ) => total.concat( current.purchaseOrders || [] ),
				[]
			);

			return uniqueByKey( purchaseOrders, "id" );
		}

		return [];
	}

	get purchaseOrderErrors() {
		if ( this.purchaseOrders ) {
			const errors = this.purchaseOrders.reduce(
				( total, current ) => total.concat( current.errors || [] ),
				[]
			);

			return uniqueByKey( errors, "id" );
		}

		return [];
	}

	get salesOrders() {
		if ( this.schedules ) {
			const salesOrders = this.schedules.reduce(
				( total, current ) => total.concat( current.salesOrders || [] ),
				[]
			);

			return uniqueByKey( salesOrders, "id" );
		}

		return [];
	}

	get salesOrderErrors() {
		if ( this.salesOrders ) {
			const errors = this.salesOrders.reduce(
				( total, current ) => total.concat( current.errors || [] ),
				[]
			);

			return uniqueByKey( errors, "id" );
		}

		return [];
	}

	resource() {
		return "yard/trips";
	}
}
